import TitlePage from "components/TitlePage";
import { useHistory, useLocation } from "react-router-dom"
import { AppBody } from "styles/base";
import Success from "../../sucess/Success";

export const RelatorioSuccess = (link: string) => {
    const navigate = useHistory();
    const location = useLocation();

    const estornoSuccess = () => {
        location.state ? navigate.push(`/home/relatorios/distribuidos/detalhe${location.state}`) : navigate.push(`/home/relatorios`)
    };

    return <>
        <AppBody id="app-body">
        <TitlePage title="Relatórios" />
        <Success onSuccess={estornoSuccess} label={'Cashback estornado com sucesso!!'} iconSuccess={false} />
        </AppBody> 
    </>
}